import React from 'react';
import { connect } from "react-redux";
import withRouter from '../utils/withRouter'
import DateFormatter from '../utils/dateFormatter';

class SubHeader extends React.Component {
    constructor(props, context) { 
        super(props, context);
      
        var segments = props.location.pathname.split('/');
       
        if (props.match && props.match.params) {
            Object.keys(props.match.params).map(f => {
            var i = segments.indexOf(f);
            if(i != -1) {
                segments[i] = props.match.params[f]
            }
            })
        }
      
        this.state = {
            paths: segments
        }
    }

    render() {
      
        return (
                <div style={{marginLeft: 40}}>

                    {this.props.showBack && (
                        <div className="mobile-only" style={{marginBottom: 6}}>
                            <button
                                onClick={this.props.onBack ? this.props.onBack : () => this.props.navigate(-1)}
                                style={{
                                    background: 'none',
                                    border: 'none',
                                    color: '#a6b0cf',
                                    fontSize: 14,
                                    padding: '4px 0',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: 4
                                }}
                            >
                                <i className="mdi mdi-arrow-left"></i> Back
                            </button>
                        </div>
                    )}

                        <h3 className="row text-themecolor">{ this.props.title ? this.props.title.toUpperCase()
                            : this.state.paths[this.state.paths.length-1] ? 
                            this.state.paths[this.state.paths.length-1].toUpperCase()
                            : null}

                            {this.props.data ? this.props.data.amendedDate && this.props.data.amendedBy ?
                            <span className="page-meta-pill"><span className="mdi mdi-pencil-outline"></span> {this.props.data.amendedBy} · <DateFormatter date={this.props.data.amendedDate} /></span>
                                : this.props.data.createdBy && this.props.data.creationDate ?
                                <span className="page-meta-pill"><span className="mdi mdi-plus-circle-outline"></span> {this.props.data.createdBy} · <DateFormatter date={this.props.data.creationDate} /></span>
                                : null
                            : null}
                        </h3>

                   

                    <div className="row align-self-center">
                        <ol className="breadcrumb">
                            {this.state.paths.map((f, i) => f === "" ? <li key={'bread-' + i} className="breadcrumb-item"><a href="#" >home</a></li> 
                                :  i < this.state.paths.length-1 ? <li key={'bread-' + i} className="breadcrumb-item"><a href="#">{f.toLowerCase()}</a></li>
                                :  <li key={'bread-' + i} className="breadcrumb-item active">{this.state.paths[this.state.paths.length-1].toLowerCase()}</li>
                                )
                            }
                        </ol>
                    </div>
            
                </div> 
        )
    }

}

export default connect()(withRouter(SubHeader));
